import React from 'react'
import { LoadMoreButton, LoadMorePaginator } from 'stream-chat-react'

const MessagingLoadMoreButton = props => (
  <LoadMoreButton {...props}>Load More</LoadMoreButton>
)

const MessagingLoadMorePaginator = props => (
  <LoadMorePaginator {...props} LoadMoreButton={MessagingLoadMoreButton} />
)

export default MessagingLoadMorePaginator
